import { ChangeDetectorRef, Component, computed, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
/* rxjs */
import { Subject, takeUntil } from 'rxjs';
/* angular material */
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
/* ngrx */
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/models/appState';
import { UserInfo } from 'src/app/models/users/user.models';
import { Auth } from 'src/app/domains/auth';
import { Menu, MenuItem } from 'src/app/models/menu/menu.models';
import { environment } from 'src/environments/environment';
import { WindowResizeHelper } from 'src/app/domains/shared/services/helpers/window-resize-helper';
import { ApplicationTitleConstants } from 'src/app/models/constants/menuItems.constants';
import { AuthHelperService } from 'src/app/domains/auth/services';


@Component({
  selector: 'app-side-nav',
  imports: [MatSidenavModule,MatToolbarModule,MatListModule,MatIconModule,CommonModule,RouterModule],
  providers: [Auth],
  templateUrl: './side-nav.html',
  styleUrl: './side-nav.scss',
})

export class SideNav implements OnInit, OnDestroy {

  openedItem: string | null = null;
  mobileQuery:                                                    MediaQueryList;
  openedItems = new Set<string>();
  userName=                                                       '';
  selectedLanguage=                                               "en";
  userDestroyed$:                                                 Subject<void> = new Subject<void>();
  MenuDestroyed$:                                                 Subject<void> = new Subject<void>();
  private _mobileQueryListener: () => void;

  /* signals */
  readonly menuItems =                                  signal<MenuItem[]>([]);
  readonly filledMenuItems =                            signal<MenuItem[]>([]);
  readonly isMobile=                                    signal<boolean>(false);
  readonly title = computed<string>(() => 
    this.isMobile() 
    ? ApplicationTitleConstants.SHORT_TITLE 
    : ApplicationTitleConstants.FULL_TITLE
  );

  /*
  * Injections
  */
  private authComponent: Auth =                                   inject(Auth);
  private store: Store<AppState> =                                inject(Store);
  changeDetectorRef: ChangeDetectorRef =                          inject(ChangeDetectorRef);
  media: MediaMatcher =                                           inject(MediaMatcher);
  windowResizeHelper: WindowResizeHelper =                        inject(WindowResizeHelper);
  authHelperService: AuthHelperService =                          inject(AuthHelperService);

  constructor() {

    this.mobileQuery = this.media.matchMedia(`(max-width: ${environment.mobileViewBreakPoint}px)`);
    this._mobileQueryListener = () => this.changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
   
    this.getWindowWidth();
    this.getUserInfo();
    this.getMenuItems();
  }

  getWindowWidth():void{

    this.windowResizeHelper.getWindowWidth().subscribe((width : number) => {

      this.isMobile.set( width <= environment.mobileViewBreakPoint );
    })
  }

  getMenuItems():void{
    
    this.store.select( AppState => AppState.Menu ).pipe(takeUntil( this.MenuDestroyed$ )).subscribe(( menu : Menu ) => { 
      
      const { items } = menu || {};

      this.menuItems.set( items );
      this.filledMenuItems.set( items );
    })
  }


  getUserInfo():void{
    
    this.store.select( AppState => AppState.User ).pipe(takeUntil( this.userDestroyed$ )).subscribe(( user : UserInfo ) => { 
      
      if( user.name )this.userName = user.name.split(' ')[0] 
    })
  }

  logout():void{
    
    this.authComponent.logout();
  }

  toggleSubMenu(itemName: string): void {

    if (this.openedItems.has(itemName)) {

      this.openedItems.delete(itemName);

    } else {

      this.openedItems.add(itemName);
    }
    // Forzar actualización si usas signals o ChangeDetection
  }

  FilterMenuItems( e:Event ):void{

    const value = (e.target as HTMLInputElement).value; 

    if(value.length > 0){

      this.menuItems.set(this.filledMenuItems().filter((a) => {
              
        if(a.name){
      
          return a.name.toLowerCase().includes(value.toLowerCase());
      
        }else{
      
          return '';
        }
      }))
    
    }else{
    
      this.menuItems.set(this.filledMenuItems());
    }
  }

  

  ngOnDestroy(): void {

    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.userDestroyed$.next();
    this.userDestroyed$.complete();
    this.MenuDestroyed$.next();
    this.MenuDestroyed$.complete();
  }
}
